const config = {
    finway: {
        endpointUrl: process.env.REACT_APP_FINWAY_ENDPOINT ?? "http://localhost:5000/api"
    },
    firebase: {
        bucketUrl: process.env.REACT_APP_FIREBASE_BUCKET_URL
    }
};

export default config;